export enum ParameterType {

    AccountId = "accountId",
    Window = "win",
    PropCheckout = "propCheckout",
    PropAddons = "propAddons",
    PackageId = "packageId",
    Dpk = "dpk",
    CloseSelf = "closeSelf",
}
